__turbopack_context__.v({
  "verticalDivider": "VerticalDivider-module-scss-module__3UgM_W__verticalDivider",
});
